import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';


 

 
  
 

export default function Basketball_Home_Ar() {
    const jsonbasket = variables.basename_url +'updates/index/Athlethixnet_HomeAr_basketball.json';
 
    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
 
    
    async function refda() {  
       
        //  To Show or Hidden Header And Footer
      document.getElementById('Arabic_Header').hidden = false;
      document.getElementById('Arabic_Footer').hidden = false;
      //

//
document.getElementById('Main_Dir').dir = "rtl";
  
//


      setNisLoading(true);


      Get_Data_Cricket_Home_Ar();
  
    };
   
    useEffect(() => {
      
       
        setNisLoading(true);
   
        refda();
           },[] )

   

 
           
           const [JsonArray, setJsonArray] = React.useState([]);
           async function Get_Data_Cricket_Home_Ar(){
         
            JsonArray.splice(0);  //to clear All data in your page
        
           setNisLoading(true);
        
           axios.get(jsonbasket)  
        
                 .then(function (response) {
                 setNisLoading( false);
        
                   console.log(response.data);
               
                  
             
        
                 for (let i = 0; i <=2 && i < response.data.length; i++) {
                 
                    JsonArray.push({
                
                    news_title: response.data[i].news_title,
                    news_date:response.data[i].news_date.split(" ")[0],
                     news_imagename:response.data[i].Image   ,
                    link:response.data[i].link,
                    Description:response.data[i].Description.replace("https://menafn.com/",variables.domain_name + "/") .replace("https://menafn.com",variables.domain_name  ) .replace("MENAFN",variables.domain) .replace("MENAFN",variables.domain)  ,
                    Category:response.data[i].Category,
                  
                  })
                  }
            })      
           }
             
 
         
             
 
     
            return (
          <>
 
 
 

 
<div className="finance-box mt-40">
              <div className="section-title">
                <a href='basketball_Ar'>
                <h3 className="title float-right"> كرة السله  </h3>
                <br></br>
                </a>
              </div>
              <div className="finance-items">
             
              {JsonArray.map(da=>     
  
  <div key= {da.news_title}  > 
                    
                <div className="finance-item">
                  <div className="finance-thumb">
                   
                    <a  href={ da.link }>
                    <img className='BaskteImg' src={da.news_imagename} alt="gallery" />
                    </a>

                    <div class="finance-date">
                    {/* <span className=''>{new Date(da.news_date).toLocaleDateString('ar-GB')}</span> */}
                    <span>{new Date(da.news_date).toLocaleDateString('ar-EG')}</span>
                                        </div>

                  </div>
                  <div className="finance-content">
                    <h3 className="title1 JUUSTIFY"><a className='' href={ da.link }>{da.news_title}</a></h3>
                    <a href={ da.link }> <p className='JUUSTIFY A-Color' >{parse(da.Description)}</p></a>
                    
           
                  </div>
                </div>
           
              </div>
              )}
                </div>
            </div>
 
 
 
         </>
        );
    }


  
